import React, { useRef, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { Visibility, Receipt, Payment, Reorder, Assessment } from '@material-ui/icons';

import {
  ADM,
  GESTOR_UNIDATA_COMERCIAL,
  GESTOR_UNIDATA_FINANCEIR,
} from '~/constants/perfil';

import moment from 'moment';

import { number, downloadFile } from '~/helpers';

import { UnidataTable } from '~/components';

import {  
  findOperacaoRadAdmDadosFaturamentoUnidata,
  recordFiltering,
} from '~/store/modules/operacaoradadmdadosfaturamentounidata/actions';

import DetalhePreFatura from './components/DetalhePreFatura';

import AdmNumeroNotaFiscal from './components/AdmNumeroNotaFiscal';

import AdmPagamentoNotaFiscal from './components/AdmPagamentoNotaFiscal';

import AdmNumeroPedido from './components/AdmNumeroPedido';

function OperacaoRadAdmDadosFaturamentoUnidataLista() {

  const dispatch = useDispatch();

  const { profile } = useSelector((state) => state.user);

  const buttons = [];

  const [itemSelecionado, setItemSelecionado] = React.useState({});

  const [lPemiteEditarComercial, setLPemiteEditarComercial] = useState(false);
  const [lPemiteEditarFinanceiro, setLPemiteEditarFinanceiro] = useState(false);
  const [lPemiteEditarFinanceiroPagamento, setLPemiteEditarFinanceiroPagamento] = useState(false);

  const data = useSelector(
    (state) => state.operacaoradadmdadosfaturamentounidata
  );

  const admNumeroNotaFiscalRef = useRef(null);
  const admPagamentoNotaFiscalRef = useRef(null);
  const admNumeroPedidoRef = useRef(null);
  const detalhePreFaturaRef = useRef(null);

  const handleUpdate = React.useCallback(() => {
    dispatch(recordFiltering(data.params));
  }, [data.params]);

  const openWin = React.useCallback((url) => {    
    window.open(url, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=1,left=1, fullscreen");
  }, []);

  const openWinBaixarArquivo = React.useCallback((url) => {
    downloadFile(url);
  }, []);

  const HandleAdmNumeroPedido = React.useCallback((value) => {
    if ((value.fatu_status === 4)) {
      admNumeroPedidoRef.current.handleToggleModal(value)
    } else {
      toast.error('O status do registro não permite essa ação.');
    }
  }, [admNumeroPedidoRef]);

  const HandleAdmNumeroNotaFiscal = React.useCallback((value) => {
    if ((value.fatu_status === 5)) {
      admNumeroNotaFiscalRef.current.handleToggleModal(value)
    } else {
      toast.error('O status do registro não permite essa ação.');
    }
  }, [admNumeroNotaFiscalRef]);

  const HandleAdmParamentoNotaFiscal = React.useCallback((value) => {    
    if ((value.fatu_status === 6)) {
      admPagamentoNotaFiscalRef.current.handleToggleModal(value)
    } else {
      toast.error('O status do registro não permite essa ação.');
    }
  }, [admPagamentoNotaFiscalRef]);

  const status = useMemo(() => [    
    { value: 'Aguardando Emissão da Fatura', label: '5' },
    { value: 'Fatura enviada para Órgão', label: '6' },
    { value: 'Fatura Paga', label: '7' },
    { value: 'Vencida', label: '100' },
  ],[]);

  const historicoPeriodo = React.useCallback((value) => {
    openWinBaixarArquivo(value.cosi_url_aplic_rel_rad_getpdf);
  }, []);

  const header = useMemo(() => [
    {
      id: 'orga_sigla',
      label: 'Órgão Sigla',
      align: 'left',
    },
    {
      id: 'fatu_codigo',
      label: 'Pré-fatura',
      filter: {
        type: 'text',
      },
      align: 'right',
    },
    {
      id: 'fatu_periodo',
      label: 'Período',
      align: 'center',
    },
    {
      id: 'fatu_datahora_geracao',
      label: 'Data Geração',
      align: 'center',
      formatted: (value) => (value !== null ? moment(value).format('DD/MM/YYYY') : '-'),
    },
    {
      id: 'fatu_status_str',
      label: 'Status',
      align: 'center',
      converter: status,
      filter: profile.perfcodigo !== String(GESTOR_UNIDATA_COMERCIAL) ? {
        type: 'select',
        options: status,
      } : undefined,
    },
    {
      id: 'fatu_valor_servico',
      label: 'Valor do Serviço (R$)',
      formatted: (value) => number(value, 'currency'),
      align: 'right',
    },
    {
      id: 'fatu_valor_nota_fiscal',
      label: 'Valor Nota Fiscal (R$)',
      formatted: (value) => number(value, 'currency'),
      align: 'right',
    },
    {
      id: 'fatu_total_retencao',
      label: 'Total das retenções (R$)',
      formatted: (value) => number(value, 'currency'),
      align: 'right',
    },
    {
      id: 'usua_nome_gestor_validacao',
      label: 'Aprovado por',
      align: 'left',
    },
    {
      id: 'fatu_datahora_validacao_gestor',
      label: 'Aprovado em',
      align: 'center',
      formatted: (value) => (value !== null ? moment(value).format('DD/MM/YYYY') : '-'),      
    },

    {
      id: 'fatu_numero_pedido',
      label: 'Pedido',
      filter:  profile.perfcodigo !== String(GESTOR_UNIDATA_COMERCIAL) ? {
        type: 'text',
      }: undefined,
      align: 'right',
    },
    {
      id: 'fatu_data_envio_fatura',
      label: 'Data do Pedido',
      align: 'center',
      formatted: (value) => (value !== null ? moment(value).format('DD/MM/YYYY') : '-'),      
    },
    {
      id: 'fatu_nota_fiscal',
      label: 'Nota Fiscal',
      align: 'right',
    },
    {
      id: 'fatu_data_fatura',
      label: 'Data Envio NF',
      align: 'center',
      formatted: (value) => (value !== null ? moment(value).format('DD/MM/YYYY') : '-'),      
    },
    {
      id: 'fatu_data_vencimento',
      label: 'Data Vencimento NF',
      align: 'center',
      formatted: (value) => (value !== null ? moment(value).format('DD/MM/YYYY') : '-'),
    },

    {
      id: 'fatu_data_pagamento',
      label: 'Pago em',
      align: 'center',
      formatted: (value) => (value !== null ? moment(value).format('DD/MM/YYYY') : '-'),      
    },
    {
      id: 'fatu_dias_vencimento',
      label: 'Dias Para Vencimento',
      align: 'center',
      styled: (value) => value < 0 ? ({ color: '#ff0000'}) : ({ color: '#00B300'}) ,
    },
    {
      id: 'fatu_dias_pagto_apos_vencimento',
      label: 'Pagos após vencimento',
      align: 'center',
    },

  ], []);

  const headerHabbuttons = useMemo(() => [
    buttons.push({
      title: 'Relatório analítico de despesas',
      action: (value) => detalhePreFaturaRef.current.handleToggleModal(value),
      icon: <Visibility />,
    }),

    buttons.push({
      title: 'Dados do Período',
      action: (value) => historicoPeriodo(value),
      icon: <Assessment />,
    }),

    (profile.perfcodigo === String(GESTOR_UNIDATA_COMERCIAL)) && (lPemiteEditarComercial === 'S') ?
      buttons.push({
        title: 'Número Pedido',
        action: (value) => HandleAdmNumeroPedido(value),
        icon: <Reorder />,
      })
      : '',

    (profile.perfcodigo === String(GESTOR_UNIDATA_FINANCEIR)) && (lPemiteEditarFinanceiro === 'S') ?
      buttons.push({
        title: 'Número Nota Fiscal',
        action: (value) => HandleAdmNumeroNotaFiscal(value),
        icon: <Receipt />,
      })
      : '',

    (profile.perfcodigo === String(GESTOR_UNIDATA_FINANCEIR)) && (lPemiteEditarFinanceiroPagamento === 'S') ?
      buttons.push({
        title: 'Pagamento Nota Fiscal',
        action: (value) => HandleAdmParamentoNotaFiscal(value),
        icon: <Payment />,
      })
      : '',

  ], [data, itemSelecionado, profile, 
      lPemiteEditarComercial, lPemiteEditarFinanceiro, lPemiteEditarFinanceiroPagamento]);

  const registroSelecionado = React.useCallback((values) => {

    switch (profile.gloperfilid) {
      case GESTOR_UNIDATA_COMERCIAL:
        let vlPemiteEditarComercial = 'N';
        if (values.fatu_status === 4) {
          vlPemiteEditarComercial = 'S';
        }
        setLPemiteEditarComercial(vlPemiteEditarComercial);
        break;
      case GESTOR_UNIDATA_FINANCEIR:
        let vlPemiteEditarFinanceiro = 'N';
        let vlPemiteEditarFinanceiroPagamento = 'N';
        if (values.fatu_status === 5) {
          vlPemiteEditarFinanceiro = 'S';
        }
        if (values.fatu_status === 6) {
          vlPemiteEditarFinanceiroPagamento = 'S';
        }
        setLPemiteEditarFinanceiro(vlPemiteEditarFinanceiro);
        setLPemiteEditarFinanceiroPagamento(vlPemiteEditarFinanceiroPagamento);
        break;
      default:
        setLPemiteEditarComercial('N');
        setLPemiteEditarFinanceiro('N');
        setLPemiteEditarFinanceiroPagamento('N');
    }
    setItemSelecionado(values);

  }, [data])

  const filter = useMemo(() => [
    {
      id: 'orga_codigo',
      label: 'Órgão',
      type: 'autocomplete',
      autocomplete: {
        url: 'orgaos',
        label: 'orga_nome',
        unique: 'orga_codigo',
        params: {
          fieldlist: 'orga_codigo, orga_nome',
        }
      }
    }
  ], []);

  return (
    <>         
      <UnidataTable
        create={false}
        delete={false}
        update={false}
        fixed
        header={header}
        find={findOperacaoRadAdmDadosFaturamentoUnidata}
        redux={data}        
        read={recordFiltering}
        actions={buttons}
        detach="fatu_codigo"
        custom={filter}
        onRow={(values) => registroSelecionado(values)}
      />

      <AdmNumeroNotaFiscal ref={admNumeroNotaFiscalRef} update={handleUpdate} name="AdmNumeroNotaFiscal" />
      <AdmPagamentoNotaFiscal ref={admPagamentoNotaFiscalRef} update={handleUpdate} name="AdmPagamentoNotaFiscal" />
      <AdmNumeroPedido ref={admNumeroPedidoRef} update={handleUpdate} name="AdmNumeroPedido" />
      <DetalhePreFatura ref={detalhePreFaturaRef} update={() => handleUpdate()} name="DetalhePreFatura" />

    </>
  );
}

export default OperacaoRadAdmDadosFaturamentoUnidataLista;
